export default __webpack_public_path__ + "static/media/gallery1.f646ce0f.jpg";